import { Dialog, Transition } from "@headlessui/react";
import React, { FC, Fragment, useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Checkbox from "shared/Checkbox/Checkbox";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import * as Yup from "yup";
import { useFormik } from "formik";
import { validateOTP } from "components/Common/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from 'store/reducers';
import { Helmet } from "react-helmet-async";
import Select from "shared/Select/Select";
import { Link } from "react-router-dom";
import toastr from "toastr";
import {
  clearData,
  getList as onGetList,
  updateData as onUpdateData,
  addNewData as onAddNewData,
} from "store/AppMaster/actions";
import api from "constants/api";
import { title } from "process";
import tc from "images/Terms-Condition-for-Website-1.pdf";
import states from "data/states.json";
export interface PageSignUpProps {
  className?: string;
}
toastr.options = {
  positionClass: "toast-top-right",
  timeOut: 5000,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
  showDuration: 300,
  hideDuration: 1000
};

const PageSignUp: FC<PageSignUpProps> = ({ className = "" }) => {

  const dispatch = useDispatch();
  const [signUpData, setSignUpData] = useState(false)
  const [response_email, setEmail] = useState("")
  const [response_name, setName] = useState("")
  const [isSent, setIsSent] = useState(false)
  const [isVerify, setIsVerify] = useState(false)
  const { data } = useSelector((state: RootState) => state.AppMaster);
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      title: "",
      first_name: "",
      last_name: "",
      department: "",
      designation: "",
      landLine_no: "",
      email: "",
      mobile: "",
      company_name: "",
      company_address: "",
      additional_address: "",
      gstin: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      billing_company_name: "",
      billing_company_address: "",
      billing_additional_address: "",
      billing_city: "",
      billing_state: "",
      billing_country: "",
      billing_pin_code: "",
      delivery_company_name: "",
      delivery_company_address: "",
      delivery_additional_address: "",
      delivery_city: "",
      delivery_state: "",
      delivery_country: "",
      delivery_pin_code: "",
      billing_same_as: true,
      delivery_same_as: true,
      is_agree: "",
      industry_type: [],
      tool_room_type: [],
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Select Title"),
      first_name: Yup.string().required("Please Enter First Name").matches(
        /^[A-Za-z]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      last_name: Yup.string().required("Please Enter Last Name").matches(
        /^[A-Za-z]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      department: Yup.string().required("Please Enter Department").matches(
        /^[A-Za-z ]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      designation: Yup.string().required("Please Enter Designation").matches(
        /^[A-Za-z ]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      company_name: Yup.string().required("Please Enter Company Name").matches(
        /^[A-Za-z0-9&.\- ]+$/i,
        "Must be a valid Company Name"
      ).max(50, "Must be less than  50 characters"),
      company_address: Yup.string().required("Please Enter Company Address").matches(
        /^[a-zA-Z0-9\s,'-]*$/,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      gstin: Yup.string()
        .required("Please enter GSTIN")
        .matches(
          /^[0-9A-Za-z]{15}$/,
          "Must be a valid GSTIN with 15 alphanumeric characters"
        ),
      city: Yup.string().required("Please Enter City").matches(
        /^[A-Za-z ]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      state: Yup.string().required("Please Enter State").matches(
        /^[A-Za-z ]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      country: Yup.string().required("Please Enter Country").matches(
        /^[A-Za-z ]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than  50 characters"),
      pincode: Yup.string()
        .required("Please Enter Delivery Pin Code")
        .matches(/^\d{6}$/, "Please Enter a Valid 6-digit PIN Code"),
      email: Yup.string().required("Please Enter Email").matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        "Must be a valid Email"
      ),
      mobile: Yup.string().required("Please Enter Mobile").matches(
        /^[+0-9]+$/i,
        "Please Enter Valid Mobile"
      ).min(9, "Please Enter Valid Mobile").max(10, "Please Enter Valid Mobile"),
      is_agree: Yup.boolean()
        .oneOf([true], 'You must agree to the terms and conditions')
        .required('You must agree to the terms and conditions'),
      // Billing information
      billing_company_name: Yup.string().test('is-billing-required', 'Please Enter Billing Company Name', function (value) {
        // Check if sameAsAbove is false and billing_company_name is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),
      billing_company_address: Yup.string().test('is-billing-required', 'Please Enter Billing Company Address', function (value) {
        // Check if sameAsAbove is false and billing_company_address is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),
      billing_additional_address: Yup.string().test('is-billing-required', 'Please Enter Billing Additional Address', function (value) {
        // Check if sameAsAbove is false and billing_additional_address is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),
      billing_city: Yup.string().test('is-billing-required', 'Please Enter Billing City', function (value) {
        // Check if sameAsAbove is false and billing_city is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),
      billing_state: Yup.string().test('is-billing-required', 'Please Enter Billing State', function (value) {
        // Check if sameAsAbove is false and billing_state is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),
      billing_country: Yup.string().test('is-billing-required', 'Please Enter Billing Country', function (value) {
        // Check if sameAsAbove is false and billing_country is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),
      billing_pin_code: Yup.string().test('is-billing-required', 'Please Enter Billing Pin Code', function (value) {
        // Check if sameAsAbove is false and billing_pin_code is empty
        if (this.parent.billing_same_as && !value) {
          return true;
        }
        if (this.parent.billing_same_as && value) {
          return true;
        }
        if (!this.parent.billing_same_as && value) {
          return true;
        }
      }),

      // Delivery information
      delivery_company_name: Yup.string().test('is-delivery-required', 'Please Enter Delivery Company Name', function (value) {
        // Check if sameAsAbove is false and delivery_company_name is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),
      delivery_company_address: Yup.string().test('is-delivery-required', 'Please Enter Delivery Company Address', function (value) {
        // Check if sameAsAbove is false and delivery_company_address is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),
      delivery_additional_address: Yup.string().test('is-delivery-required', 'Please Enter Delivery Additional Address', function (value) {
        // Check if sameAsAbove is false and delivery_additional_address is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),
      delivery_city: Yup.string().test('is-delivery-required', 'Please Enter Delivery City', function (value) {
        // Check if sameAsAbove is false and delivery_city is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),
      delivery_state: Yup.string().test('is-delivery-required', 'Please Enter Delivery State', function (value) {
        // Check if sameAsAbove is false and delivery_state is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),
      delivery_country: Yup.string().test('is-delivery-required', 'Please Enter Delivery Country', function (value) {
        // Check if sameAsAbove is false and delivery_country is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),
      delivery_pin_code: Yup.string().test('is-delivery-required', 'Please Enter Delivery Pin Code', function (value) {
        // Check if sameAsAbove is false and delivery_pin_code is empty
        if (this.parent.delivery_same_as && !value) {
          return true;
        }
        if (this.parent.delivery_same_as && value) {
          return true;
        }
        if (!this.parent.delivery_same_as && value) {
          return true;
        }
      }),

    }),
    onSubmit: values => {
      const newData = {
        title: values["title"],
        first_name: values["first_name"],
        last_name: values["last_name"],
        department: values["department"],
        designation: values["designation"],
        landLine_no: values["landLine_no"],
        email: values["email"],
        mobile: values["mobile"],
        company_name: values["company_name"],
        company_address: values["company_address"],
        additional_address: values["additional_address"],
        gstin: values["gstin"],
        city: values["city"],
        state: values["state"],
        country: values["country"],
        pincode: values["pincode"],

        billing_company_name: (!values["billing_same_as"]) ? values["billing_company_name"] : values["company_name"],
        billing_company_address: (!values["billing_same_as"]) ? values["billing_company_address"] : values["company_address"],
        billing_additional_address: (!values["billing_same_as"]) ? values["billing_additional_address"] : values["additional_address"],
        billing_city: (!values["billing_same_as"]) ? values["billing_city"] : values["city"],
        billing_state: (!values["billing_same_as"]) ? values["billing_state"] : values["state"],
        billing_country: (!values["billing_same_as"]) ? values["billing_country"] : values["country"],
        billing_pin_code: (!values["billing_same_as"]) ? values["billing_pin_code"] : values["pincode"],

        delivery_company_name: (!values["delivery_same_as"]) ? values["delivery_company_name"] : values["company_name"],
        delivery_company_address: (!values["delivery_same_as"]) ? values["delivery_company_address"] : values["company_address"],
        delivery_additional_address: (!values["delivery_same_as"]) ? values["delivery_additional_address"] : values["additional_address"],
        delivery_city: (!values["delivery_same_as"]) ? values["delivery_city"] : values["city"],
        delivery_state: (!values["delivery_same_as"]) ? values["delivery_state"] : values["state"],
        delivery_country: (!values["delivery_same_as"]) ? values["delivery_country"] : values["country"],
        delivery_pin_code: (!values["delivery_same_as"]) ? values["delivery_pin_code"] : values["pincode"],

        billing_same_as: values["billing_same_as"],
        delivery_same_as: values["delivery_same_as"],
        role: "Customer",
        industry_type: values["industry_type"],
        tool_room_type: values["tool_room_type"],
      };
      dispatch(onAddNewData(newData, "", api.frontRegister))
      setSignUpData(true);
    },
  });

  const validationOtp = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: "",
      otp: ""
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Please Enter OTP").matches(
        /^[+0-9]+$/i,
        "Please Enter Valid OTP"
      ).min(6, "Please Enter Valid OTP").max(6, "Please Enter Valid OTP")
    }),
    onSubmit: values => {
      const newData = {
        email: response_email,
        otp: values["otp"]
      };
      // dispatch(onAddNewData(newData, "", api.verifyOTP))
      const apiUrl = process.env.REACT_APP_API_URL + api.verifyOTP
      validateOTP(apiUrl, newData)
        .then((data) => {
          toastr.success('Your request has been submitted successfully for further process and you will shortly receive the reply');
          setTimeout(() => {
            window.location.href = "/login"
          }, 2000);
          setIsVerify(true);
        })
        .catch((error) => {
          setIsVerify(false);;
        });
    },
  });

  const resendOTP = () => {
    const newData = {
      email: response_email,
      name: response_name
    };
    dispatch(onAddNewData(newData, "", api.resendOTP))
  }

  if (data && data.customerDetails != null && signUpData == true) {
    setTimeout(() => {
      setSignUpData(false);
      setEmail(data.customerDetails.email);
      setName(data.customerDetails.name);
      setIsSent(true);
      // Scroll to top when showing OTP section
      window.scrollTo(0, 0);
    }, 1000);
  }

  if (data && data.otpDetails != null && isVerify == true) {
    setIsVerify(false);
    /* window.location.href = "/login" */
  }

  type SectionType = 'company' | 'billing' | 'delivery';
  const [activeSection, setActiveSection] = useState<SectionType | null>(null);

  const onOpenActive = (section: SectionType) => {
    if (activeSection !== section) {
      setActiveSection(section);
    } else {
      setActiveSection(null);
    }
  };

  const onCloseActive = () => {
    setActiveSection(null);
  };


  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>Sign up | Vijaydeep</title>
      </Helmet>
      {isSent && (
        <div className="container mb-24 lg:mb-32">
          <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
            Verify Email Address using OTP
          </h2>
          <div className="max-w-md mx-auto space-y-6 ">
            {/* FORM */}
            <form className="grid grid-cols-1 gap-6"
              onSubmit={e => {
                e.preventDefault();
                validationOtp.handleSubmit();
                return false;
              }}
              method="post">
              <label className="block">
                <span className="text-neutral-800 dark:text-neutral-200">
                  OTP
                </span>
                <Input
                  type="text"
                  placeholder=""
                  className="mt-1"
                  name="otp"
                  onChange={validationOtp.handleChange}
                  onBlur={validationOtp.handleBlur}
                  value={validationOtp.values.otp || ""}
                />
                {validationOtp.errors.otp ? (
                  <small className="text-rose-600">{validationOtp.errors.otp}</small>
                ) : null}
              </label>
              <ButtonPrimary type="submit">Verify OTP</ButtonPrimary>
            </form>

            {/* ==== */}
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
              Don't get OTP? {` `}
              <Link className="text-primary-600" to="#" onClick={resendOTP}>
                Resend OTP
              </Link>
            </span>
          </div>
        </div>
      )}

      {!isSent && (
        <div className="container mb-24 lg:mb-32">
          <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
            Signup
          </h2>

          {/* FORM */}
          <form
            onSubmit={e => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
            method="post"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="uppercase font-semibold text-xl dark:text-neutral-200 tracking-wider mb-6">User Details</h3>

                <div className="mb-3">
                  <label className="block">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Title
                    </span>
                    <Select className="mt-2 w-full"
                      onChange={e => {
                        // Convert the checked state to a boolean value
                        const isChecked = e.target.value;
                        validation.handleChange({
                          target: {
                            name: 'title',
                            value: isChecked,
                          },
                        });
                      }}
                    >
                      <option value="" >Select Title</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Miss">Miss</option>
                      <option value="Ms">Ms</option>
                    </Select>
                    {validation.errors.title ? (
                      <small className="text-rose-600">{validation.errors.title}</small>
                    ) : null}
                  </label>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6">
                  <div className="mb-3">
                    <label className="block">
                      <span className="text-neutral-800 dark:text-neutral-200">
                        First Name
                      </span>
                      <Input
                        type="text"
                        placeholder=""
                        className="mt-1"
                        name="first_name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.first_name || ""}
                      />
                      {validation.errors.first_name ? (
                        <small className="text-rose-600">{validation.errors.first_name}</small>
                      ) : null}
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="text-neutral-800 dark:text-neutral-200">
                        Last Name
                      </span>
                      <Input
                        type="text"
                        placeholder=""
                        className="mt-1"
                        name="last_name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.last_name || ""}
                      />
                      {validation.errors.last_name ? (
                        <small className="text-rose-600">{validation.errors.last_name}</small>
                      ) : null}
                    </label>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6">
                  <div className="mb-3">
                    <label className="block">
                      <span className="text-neutral-800 dark:text-neutral-200">
                        Department
                      </span>
                      <Input
                        type="text"
                        placeholder=""
                        className="mt-1"
                        name="department"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.department || ""}
                      />
                      {validation.errors.department ? (
                        <small className="text-rose-600">{validation.errors.department}</small>
                      ) : null}
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="text-neutral-800 dark:text-neutral-200">
                        Designation
                      </span>
                      <Input
                        type="text"
                        placeholder=""
                        className="mt-1"
                        name="designation"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.designation || ""}
                      />
                      {validation.errors.designation ? (
                        <small className="text-rose-600">{validation.errors.designation}</small>
                      ) : null}
                    </label>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6">
                  <div className="mb-3">
                    <label className="block">
                      <span className="text-neutral-800 dark:text-neutral-200">
                        Mobile
                      </span>
                      <Input
                        type="text"
                        placeholder=""
                        className="mt-1"
                        name="mobile"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.mobile || ""}
                      />
                      {validation.errors.mobile ? (
                        <small className="text-rose-600">{validation.errors.mobile}</small>
                      ) : null}
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="text-neutral-800 dark:text-neutral-200">
                        LandLine No
                      </span>
                      <Input
                        type="text"
                        placeholder=""
                        className="mt-1"
                        name="landLine_no"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.landLine_no || ""}
                      />
                      {validation.errors.landLine_no ? (
                        <small className="text-rose-600">{validation.errors.landLine_no}</small>
                      ) : null}
                    </label>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="block">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Official Email ID (Login ID) (OTP will be sent)
                    </span>
                    <Input
                      type="email"
                      name="email"
                      placeholder="example@example.com"
                      className="mt-1"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                    />
                    {validation.errors.email ? (
                      <small className="text-rose-600">{validation.errors.email}</small>
                    ) : null}
                  </label>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-0 md:gap-6">
                  <div className="mb-3">
                    <label className="block">
                      <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                        Industry Type (Multiple Selection can be done)
                      </span>
                    </label>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="industry_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Moulding Company"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Moulding Company</span>
                      </label>
                    </div>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="industry_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Mould Maker"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Mould Maker</span>
                      </label>
                    </div>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="industry_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Press Tool Manufacturing Company"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Press Tool Manufacturing Company</span>
                      </label>
                    </div>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="industry_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Stamping Company"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Stamping Company</span>
                      </label>
                    </div>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="industry_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Trader/Dealer/Reseller"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Trader/Dealer/Reseller</span>
                      </label>
                    </div>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="industry_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Merchant Exporter"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Merchant Exporter</span>
                      </label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                        Tool Room Type
                      </span>
                    </label>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="tool_room_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Captive Tool Room"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Captive Tool Room</span>
                      </label>
                    </div>
                    <div className="flex items-center text-sm sm:text-base mt-5">
                      <input
                        name="tool_room_type"
                        type="checkbox"
                        onChange={validation.handleChange}
                        value="Commercial Tool Room"
                        className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5"
                      />
                      <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                        <span className="text-slate-900 dark:text-slate-100 text-sm font-normal ">Commercial Tool Room</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {/* ------------------------------company-details-start----------------- */}
                <h3 className="uppercase font-semibold text-xl dark:text-neutral-200 tracking-wider mb-6">Company Details</h3>
                <div>
                  {/*  <Link to="" onClick={() => onOpenActive('company')}>
                    <div className="flex items-center justify-start p-6">
                      <h3 className=" text-slate-700 dark:text-slate-300 flex uppercase tracking-tight">
                        Company Details
                      </h3>
                    </div>
                  </Link> */}

                  {/* Edit section */}
                  <div>
                    {/*      <h3 className="text-lg font-semibold mb-5">Company Details</h3> */}
                    <div className="mb-3">
                      <label className="block">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Company Name
                        </span>
                        <Input
                          type="text"
                          placeholder=""
                          className="mt-2"
                          name="company_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.company_name || ""}
                        />
                        {validation.errors.company_name ? (
                          <small className="text-rose-600">{validation.errors.company_name}</small>
                        ) : null}
                      </label>
                    </div>
                    <div className="mb-3">
                      <label className="block">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Company Address
                        </span>
                        <Input
                          type="text"
                          placeholder=""
                          className="mt-2"
                          name="company_address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.company_address || ""}
                        />
                        {validation.errors.company_address ? (
                          <small className="text-rose-600">{validation.errors.company_address}</small>
                        ) : null}
                      </label>
                    </div>
                    <div className="mb-3">
                      <label className="block">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Additional Address
                        </span>
                        <Input
                          type="text"
                          placeholder=""
                          className="mt-2"
                          name="additional_address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.additional_address || ""}
                        />
                        {validation.errors.additional_address ? (
                          <small className="text-rose-600">{validation.errors.additional_address}</small>
                        ) : null}
                      </label>
                    </div>
                    <div className="mb-3">
                      <label className="block">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          GSTIN
                        </span>
                        <Input
                          type="text"
                          placeholder=""
                          className="mt-2"
                          name="gstin"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.gstin || ""}
                        />
                        {validation.errors.gstin ? (
                          <small className="text-rose-600">{validation.errors.gstin}</small>
                        ) : null}
                      </label>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6">
                      <div className="mb-3">
                        <label className="block">
                          <span className="text-neutral-800 dark:text-neutral-200">
                            City
                          </span>
                          <Input
                            type="text"
                            placeholder=""
                            className="mt-2"
                            name="city"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.city || ""}
                          />
                          {validation.errors.city ? (
                            <small className="text-rose-600">{validation.errors.city}</small>
                          ) : null}
                        </label>
                      </div>
                      <div className="mb-3 custom-dropdown">
                        <label className="block">
                          <span className="text-neutral-800 dark:text-neutral-200 mb-2 block">
                            State <span className="text-red-500">*</span>
                          </span>
                          <Select className="mt-2 w-full"
                            name="state"
                            value={validation.values.state || ""}
                            onChange={e => {
                              validation.handleChange({
                                target: {
                                  name: 'state',
                                  value: e.target.value,
                                },
                              });
                            }}
                            onBlur={validation.handleBlur}
                          >
                            <option value="">Select State</option>
                            {states.map((state, index) => (
                              <option key={index} value={state}>{state}</option>
                            ))}
                          </Select>
                          {validation.touched.state && validation.errors.state ? (
                            <small className="text-rose-600">{validation.errors.state}</small>
                          ) : null}
                        </label>
                      </div>


                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6">
                      <div className="mb-3">
                        <label className="block">
                          <span className="text-neutral-800 dark:text-neutral-200">
                            Country
                          </span>
                          <Input
                            type="text"
                            placeholder=""
                            className="mt-2"
                            name="country"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.country || ""}
                          />
                          {validation.errors.country ? (
                            <small className="text-rose-600">{validation.errors.country}</small>
                          ) : null}
                        </label>
                      </div>
                      <div className="mb-3">
                        <label className="block">
                          <span className="text-neutral-800 dark:text-neutral-200">
                            Pin Code
                          </span>
                          <Input
                            type="text"
                            placeholder=""
                            className="mt-2"
                            name="pincode"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.pincode || ""}
                          />
                          {validation.errors.pincode ? (
                            <small className="text-rose-600">{validation.errors.pincode}</small>
                          ) : null}
                        </label>
                      </div>
                    </div>
                    {/* Buttons to save or cancel */}
                    {/*  <div className="flex flex-col sm:flex-row">
                      <ButtonPrimary
                        className="sm:!px-7 shadow-none"
                        onClick={() => onOpenActive('billing')}
                      >
                        Next
                      </ButtonPrimary>
                      <ButtonSecondary
                        className="mt-3 sm:mt-0 sm:ml-3"
                        onClick={onCloseActive}
                      >
                        Cancel
                      </ButtonSecondary>
                    </div> */}
                  </div>
                </div>
                {/* ------------------------------company-details-end----------------- */}




                {/* ------------------------------Delivery Address-end----------------- */}

                <div className="flex items-center text-sm sm:text-base mt-5">
                  <input id="Backpacks" name="is_agree" type="checkbox"
                    onChange={e => {
                      // Convert the checked state to a boolean value
                      const isChecked = e.target.checked;
                      validation.handleChange({
                        target: {
                          name: 'is_agree',
                          value: isChecked,
                        },
                      });
                    }}
                    className="focus:ring-action-primary text-primary-500 rounded border-slate-400 hover:border-slate-700 bg-transparent dark:border-slate-700 dark:hover:border-slate-500 dark:checked:bg-primary-500 focus:ring-primary-500 w-5 h-5" />
                  <label className="pl-2.5 sm:pl-3.5 flex flex-col flex-1 justify-center select-none">
                    <span className="text-slate-900 dark:text-slate-100 text-sm font-normal">
                      I have read and agree to the
                      <Link to="/terms-and-conditions" className="text-blue-600" target="_blank"> Term and Conditions </Link>
                      and
                      <Link to="/privacy-policy" className="text-blue-600" target="_blank"> Data Privacy </Link>
                      Declaration
                    </span>
                  </label>
                </div>
                {validation.errors.is_agree ? (
                  <small className="text-rose-600">{validation.errors.is_agree}</small>
                ) : null}
                <div className="flex justify-end">
                  <ButtonPrimary
                    className="sm:!px-7 mt-5 shadow-none"
                    type="submit"
                  >
                    Sign up
                  </ButtonPrimary>
                </div>
                <span className="block text-right text-neutral-700 dark:text-neutral-300 mt-5">
                  Already have an account? {` `}
                  <Link className="text-blue-600" to="/login">
                    Sign in
                  </Link>
                </span>
              </div>
            </div>
          </form>
          {/* ==== */}
        </div>
      )}

    </div>
  );
};

export default PageSignUp;
